import { render, staticRenderFns } from "./download-conceptual-framework.vue?vue&type=template&id=c7b1fdf6"
import script from "./download-conceptual-framework.vue?vue&type=script&lang=js"
export * from "./download-conceptual-framework.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports